<template>
    <div class="scheduling-module">
        <div class="calendar-wrap">
            <div class="date">
                <div class="arrow-box" @click="handleCalendar('prev')">
                    <div class="arrow-l"></div>
                </div>
                <div>{{ year }}年{{ month }}月</div>
                <div class="arrow-box" @click="handleCalendar('next')">
                    <div class="arrow-r"></div>
                </div>
            </div>
            <div class="content">
                <div class="header">
                    <div v-for="(item, index) in weeks" :key="index">
                        <div class="weeks-item-text">{{ item }}</div>
                    </div>
                </div>
                <div class="body-days">
                    <div v-for="(item, index) in days" :key="index">
                        <div :class="`days-item ${item.current && item.date >= today && item.year + '-' + item.month == dateData ? '' : 'no-current'} ${currentDate == item.date && isMonth == item.current ? 'isActive' : ''} ${currentDate == item.date && item.current == false ? 'isNoActive' : ''}`" @click="activeItem(item.date, item.current)">
                            <div :class="`days-item-text ${item.date == today && item.year + '-' + item.month == dateData ? 'today' : ''}`" v-if="item.date && item.date == today && item.year + '-' + item.month == dateData">
                                今天
                            </div>
                            <div class="days-item-text" v-else-if="item.current != false">{{ item.date }}</div>
                            <div class="days-item-text" v-else></div>
                            <div :class="`font24 ${item.current && item.date >= today && item.year + '-' + item.month == dateData && 'date-' + item.type}`" v-if="item.current != false">
                                {{ item.text }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import request from "@/utils/request";

    export default {
        name: "myScheduling",
        data() {
            return {
                date: [],
                weeks: ["日", "一", "二", "三", "四", "五", "六"],
                days: [],
                year: 0,
                month: 0,
                today: "", // 所选日期是否是当天
                isMonth: false, // 所选日期是否属于当月
                scheduleData: [], // 排班数据
                dateData: "", // 当前查询的年月
                currentDate: ""// 当前点击的日期数
            };
        },
        mounted() {
            this.initdateData();
        },
        methods: {
            // 初始化时间
            initdateData() {
                var date = new Date();
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                this.today = day
                this.dateData = year + "-" + month
                this.updateDays(year, month);
                this.getScheduleData(year, month);
            },
            // 获取排班数据
            getScheduleData(year, month) {
                request({
                    url: "/employee/schedule/getList?date=" + year + "-" + month,
                    method: "get",
                })
                    .then((res) => {
                        this.scheduleData = res.data
                        this.updateDays(year, month);
                    })
            },
            // 切换月份
            handleCalendar(handle) {
                const year = this.year;
                const month = this.month;
                if (handle === "prev") {
                    let newMonth = month - 1;
                    let newYear = year;
                    if (newMonth < 1) {
                        newYear = year - 1;
                        newMonth = 12;
                    }
                    this.getScheduleData(newYear, newMonth);
                    this.year = newYear
                    this.month = newMonth

                } else {
                    let newMonth = month + 1;
                    let newYear = year;
                    if (newMonth > 12) {
                        newYear = year + 1;
                        newMonth = 1;
                    }
                    this.getScheduleData(newYear, newMonth);
                    this.year = newYear
                    this.month = newMonth
                }
            },
            // 更新月份天数
            updateDays(year, month) {
                var days = [];
                var dateDay, dateWeek, lastWeek;
                dateDay = this.getThisMonthDays(year, month);
                dateWeek = this.getFirstDayOfWeek(year, month);
                lastWeek = this.getLastDayOfWeek(year, month);
                const typeMap = {
                    早班: 1,
                    中班: 2,
                    晚班: 3,
                    休班: 4,
                    未排班: 5,
                };
                //向数组中添加天
                for (let index = 1; index <= dateDay; index++) {
                    days.push({
                        date: index,
                        current: true, // 是不是当月的日期
                        month: month,
                        year: year,
                        text: this.scheduleData[index - 1]?.secheduleType,
                        type:
                            typeMap[this.scheduleData[index - 1]?.secheduleType] ||
                            undefined,
                    });
                }
                // 获取本月第一天的上一天是几号
                let time =
                    new Date(year + "/" + month + "/" + 1).getTime() - 24 * 60 * 60 * 1000;
                let yesterday = new Date(time).getDate();
                //向数组中添加，一号之前应该空出的空格
                for (let index = 1; index <= dateWeek; index++) {
                    days.unshift({
                        date: yesterday--,
                        current: false,
                    });
                }
                //向数组中添加，最后一天之后应该空出的空格
                for (let index = 1; index <= 6 - lastWeek; index++) {
                    days.push({
                        date: index,
                        current: false,
                    });
                }
                this.days = days
                this.year = year
                this.month = month

            },
            // 获取当月共多少天
            getThisMonthDays(year, month) {
                return new Date(year, month, 0).getDate();
            },
            // 获取当月第一天星期几
            getFirstDayOfWeek(year, month) {
                let _time =
                    new Date(year + "/" + (month + 1) + "/" + 1).getTime() -
                    24 * 60 * 60 * 1000;
                let lastDay = new Date(_time).getDate();
                return new Date(Date.UTC(year, month - 1, 1)).getDay();
            },
            // 获取当月第一天星期几
            getLastDayOfWeek(year, month) {
                let _time =
                    new Date(year + "/" + (month + 1) + "/" + 1).getTime() -
                    24 * 60 * 60 * 1000;
                let lastDay = new Date(_time).getDate();
                return new Date(Date.UTC(year, month - 1, lastDay)).getDay();
            },
            // 点击时背景变色
            activeItem(date, current) {
                if (date) {
                    this.currentDate = date // 当前点击的日期数
                    this.isMonth = current // 是否是当前月
                }
            },
        },
    };
</script>

<style scoped>
    .scheduling-module {
        box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02) inset;
        padding: 10px 10px;
    }

    .calendar-wrap {
        width: 720px;
        margin: 0 auto;
        background: #ffffff;
    }

    .date {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        line-height: 92.4px;
        margin: 0 41px;
        font-size: 30px;
        color: #35434c;
    }

    .arrow-box {
        width: 40px;
        height: 30px;
        display: flex;
        align-items: center;
    }

    .arrow-l {
        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-right: 10px solid #35434c;
        border-bottom: 10px solid transparent;
        margin-right: 30px;
    }

    .arrow-r {
        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-left: 10px solid #35434c;
        border-bottom: 10px solid transparent;
        margin-left: 30px;
    }

    .content {
        padding: 20px 20px 0;
    }

    .header {
        display: flex;
        flex-direction: row;
        margin-bottom: 40px;
        justify-content: space-between;
    }

    .weeks-item-text {
        width: 95px;
        line-height: 48px;
        text-align: center;
        color: #66757f;
        font-size: 28px;
        font-weight: bold;
    }

    .body-days {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        text-align: center;
        padding-bottom: 10px;
        justify-content: space-between;
    }

    .days-item {
        width: 95px;
        height: 99px;
        display: flex;
        justify-content: center;
        align-content: center;
        margin-bottom: 15px;
        color: #35434c;
        flex-direction: column;
        font-size: 28px;
        box-sizing: border-box;
    }

    .days-item-text {
        font-size: 28px;
        text-align: center;
        margin-bottom: 10px;
    }

    .today {
        color: #37dbe0;
    }

    .date-1 {
        color: #fbc200;
    }

    .date-2 {
        color: #fa9063;
    }

    .date-3 {
        color: #9a6be2;
    }

    .date-4 {
        color: #41daa5;
    }

    .date-5 {
        color: #c4ced4;
    }

    .days-item.no-current {
        color: #c4ced4;
    }

    .days-item.isActive {
        background-color: #ebfbf9;
        border: 1px solid #37dbe0;
    }

    .days-item.isNoActive {
        background-color: #fff;
        border: none;
    }
</style>
